import { ApiClient } from '../api-client';
import { LocalStorage } from '../store/local-storage';

export const clearAndDeleteToken = async (userId: string) => {
    LocalStorage.clearAuthCredentials();
    await ApiClient.deleteAuthToken(userId);
};
